// extracted by mini-css-extract-plugin
export default {"loginErrorContainer":"lxQ4Z1TSQpkkfrxa7xc2","loginErrorConfirm":"KsXm6iiKaWoJCU4Uv796","loginErrorLimitExceeded":"SSx6zxEAuGg0jdXNEE8f"};